import { Component, HostListener, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AgentComissionResponse } from 'src/app/components/admin/comissions/models/comission-agent.model';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.css']
})
export class ConfirmModalComponent implements OnInit {

  @Input() message: string;
  @Input() title: string;
  @Input() noCancel: boolean;
  @Input() agentComissions: AgentComissionResponse[];
  @Input() institutionId: number;

  outsideClick: boolean;
  commissions: AgentComissionResponse[] = [];

  constructor(public bsModalRef: BsModalRef) {}

  ngOnInit() {
    this.outsideClick = false;

    if (this.agentComissions) {
      this.commissions = this.agentComissions.map(item => ({
        ...item,
        bookingTypeDescription: this.getBookingTypeDescription(item.bookingType),
        imagePath: this.getBookingTypeImage(item.bookingType)
      }));

      console.log('Comissões carregadas:', this.commissions);
    }
  }

  private getBookingTypeDescription(type: number): string {
    const bookingTypeMap: Record<number, string> = {
      1: 'comissions-bonus-agent.label.air',        // Flight
      2: 'comissions-bonus-agent.label.hotel',      // Hotel
      4: 'comissions-bonus-agent.label.car',   // RentAcar
      8: 'comissions-bonus-agent.label.insurance',  // Insurance
      12: 'comissions-bonus-agent.label.offline'    // OfflineProduct
    };

    return bookingTypeMap[type] || 'Desconhecido';
  }

  private getBookingTypeImage(type: number): string {
    const imageMap: Record<number, string> = {
      1: 'assets/img/commission-flight.svg',      // Flight
      2: 'assets/img/commission-hotel.svg',      // Hotel
      4: 'assets/img/commission-rent-car.svg',        // RentAcar
      8: 'assets/img/commission-insurance.svg',    // Insurance
      12: 'assets/img/commission-ticket.svg'      // OfflineProduct
    };

    return imageMap[type] || 'assets/img/default.svg';
  }

  decline(): void {
    this.bsModalRef.content.callback(false);
    this.bsModalRef.hide();
  }

  accept(): void {
    if (!this.outsideClick) {
      this.bsModalRef.content.callback(true);
      this.bsModalRef.hide();
    }
  }

  @HostListener('window:keydown.esc', ['$event'])
  onEsc(event: any): void {
    if (event.keyCode === 27) {
      event.preventDefault();
      this.decline();
    }
  }

  @HostListener('window:mousedown', ['$event'])
  onClickStarted(event: MouseEvent): void {
    if ((event.target as HTMLElement).tagName === 'MODAL-CONTAINER') {
      this.outsideClick = true;
    }
  }

  @HostListener('window:mouseup', ['$event'])
  onClickStop(event: MouseEvent): void {
    if (this.outsideClick) {
      this.decline();
    }
  }
}
